//需要全局化的组件

import qtButton from "./qtButton";
// import qtButtonShell from "./qtButtonShell";
// import qtlinkShell from "./qtlinkShell";
import qtContent from "./qtContent";
import qtContentSign from "./qtContentSign";
import qtDetailLayout from "./qtDetailLayout";
import qtSearch from "./qtSearch";
import qtTable from "./qtTable";
import qtSplitLayout from './qtSplitLayout'
// import exportButton from './exportButton'
let components = {
    install: function (Vue) {
        Vue.component("qtSearch", qtSearch);
        Vue.component("qtContent", qtContent);
        Vue.component("qtButton", qtButton);
        // Vue.component("qtButtonShell", qtButtonShell);
        // Vue.component("qtLinkShell", qtlinkShell);
        Vue.component("qtContentSign", qtContentSign);
        Vue.component("qtTable", qtTable);
        Vue.component("qtDetailLayout", qtDetailLayout);
        Vue.component("qtSplitLayout",qtSplitLayout);
        // Vue.component("exportButton",exportButton);
    },
};
export default components;